<template>
  <v-text-field
    :filled="filled"
    :rounded="rounded"
    v-bind="$attrs"
    v-on="$listeners">
    <template
      v-for="slot of slotScopeKeys"
      #[slot]>
      <slot :name="slot"></slot>
    </template>
    <template
      v-if="isOptional"
      #label>
      {{ $attrs.label }} (ถ้ามี)
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'BaseTextField',
  props: {
    filled: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    isOptional: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slotScopeKeys () {
      return Object.keys(this.$scopedSlots)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep input[type="time"]::-webkit-calendar-picker-indicator {
    background: none;
    display: none;
}
</style>
